export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      title: 'Set Up Your Profile',
      description: 'Add your credentials, specialties, and availability. Customize your services and set your own rates. Wait for approval.',
      icon: 'ri-user-settings-line',
    },
    {
      number: '02',
      title: 'Offer Your Services',
      description: 'Launch teleconsults, wellness memberships, curated products, and digital resources for your clients.',
      icon: 'ri-calendar-check-line',
    },
    {
      number: '03',
      title: 'Earn Recurring Income',
      description: 'Automated billing, client retention tools, and analytics help you grow sustainable revenue streams.',
      icon: 'ri-line-chart-line',
    },
  ];

  return (
    <section id="how-it-works" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <span className="text-xs font-semibold tracking-widest uppercase text-[#4DB8D4] mb-4 block">
            The Platform
          </span>
          <h2 className="text-4xl lg:text-5xl font-serif text-gray-900">
            Three Steps to Your New Revenue Stream
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="bg-[#F5F8FC] rounded-2xl p-10 hover:shadow-lg transition-shadow duration-300 group"
            >
              <div className="mb-6">
                <div className="w-14 h-14 rounded-full border-2 border-[#4DB8D4] flex items-center justify-center">
                  <span className="text-2xl font-serif text-[#4DB8D4]">{step.number}</span>
                </div>
              </div>

              <h3 className="text-2xl font-semibold text-gray-900 mb-4">{step.title}</h3>
              <p className="text-gray-600 leading-relaxed mb-8">{step.description}</p>

              <div className="flex justify-end">
                <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center group-hover:bg-[#4DB8D4] transition-colors">
                  <i className={`${step.icon} text-2xl text-[#4DB8D4] group-hover:text-white transition-colors`}></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
